<template>
  <div class="about">
    <h1>This is an test page</h1>
  </div>
  <NavButton :properties="navButton" />
</template>

<script>
import NavButton from "@/components/NavButton.vue";

export default {
  components: {
    NavButton,
  },
  data() {
    return {
      navButton: {
        routeName: "Aanvraag",
        class:
          "btn btn-grey text-uppercase p-1 text-center link-assortiments ms-1",
        id: "",
        label: "Terug naar overzicht",
        function: undefined,
      },
      options: {
        selectors: {
          class: {
            openAccordion: false,
          },
          id: {
            name: "Rug",
          },
        },
        properties: {
          key: "rug",
          label: "Rug",
          options: [1, 2, 3, 4],
        },
      },
      value: "",
    };
  },
  computed: {},
  methods: {
    selected(value) {
      console.log(value);
      this.value = value;
    },
    // end methods
  },
  created() {},
  updated() {},
  watch: {},
};
</script>
